
  import * as glideRuntime$IAIQ5mQ3Gsdwtp2eQuxoRGfnpzFo51omWPMFMk3gfwQ from '/usr/src/app/node_modules/.pnpm/@nuxt+image@1.11.0_@netlify+blobs@9.1.2_db0@0.3.2_ioredis@5.7.0_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/glide'
import * as noneRuntime$FrqxfbjkjzGKFHzf8D6xbFVW9LyWdaG3IWsY9oD8EKs from '/usr/src/app/node_modules/.pnpm/@nuxt+image@1.11.0_@netlify+blobs@9.1.2_db0@0.3.2_ioredis@5.7.0_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/none'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "none",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "avif",
    "webp",
    "jpg",
    "png",
    "avif",
    "webp",
    "jpg",
    "png",
    "avif",
    "webp",
    "jpg",
    "png",
    "avif",
    "webp",
    "jpg",
    "png",
    "avif",
    "webp",
    "jpg",
    "png",
    "avif",
    "webp",
    "jpg",
    "png",
    "avif",
    "webp",
    "jpg",
    "png",
    "avif",
    "webp",
    "jpg",
    "png",
    "avif",
    "webp",
    "jpg",
    "png",
    "webp"
  ]
},
    providers: {
        ['glide']: { provider: glideRuntime$IAIQ5mQ3Gsdwtp2eQuxoRGfnpzFo51omWPMFMk3gfwQ, defaults: {"baseURL":""} },
  ['none']: { provider: noneRuntime$FrqxfbjkjzGKFHzf8D6xbFVW9LyWdaG3IWsY9oD8EKs, defaults: {} }
    }
  }
